// extracted by mini-css-extract-plugin
export default {"container":"lJ-z","topReviewHeading":"mJ-z","criticalReview":"nJ-z","favorableReview":"oJ-z","vsSeparator":"pJ-z"};